import { useMutation } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  CreateUserOrderExternalManagedPaymentsDetailsRequestSchema,
  CreateUserOrderExternalManagedPaymentsDetailsRequestType,
  CreateUserOrderExternalManagedPaymentsDetailsResponseSchema,
  CreateUserOrderExternalManagedPaymentsDetailsResponseType
} from '../../../services/NwExternalPaymentsServices/APIService/types';

import { useNwExternalPaymentsService } from '../useNwExternalPaymentsService';

interface UseCreateUserOrderExternalManagedPaymentsDetailsApiInterface {
  createUserOrderExternalManagedPaymentsDetailsApi: (
    input: CreateUserOrderExternalManagedPaymentsDetailsRequestType
  ) => Promise<CreateUserOrderExternalManagedPaymentsDetailsResponseType>;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: 'idle' | 'loading' | 'success' | 'error';
  reset: () => void;
}

const useCreateUserOrderExternalManagedPaymentsDetailsApi =
  (): UseCreateUserOrderExternalManagedPaymentsDetailsApiInterface => {
    const { nwExternalPaymentsServiceInstance } = useNwExternalPaymentsService();

    const createUserOrderExternalManagedPaymentsDetails = (
      requestObject: CreateUserOrderExternalManagedPaymentsDetailsRequestType
    ) => {
      try {
        CreateUserOrderExternalManagedPaymentsDetailsRequestSchema.parse(
          requestObject
        );
      } catch (error) {
        console.error('Invalid request object:', error);
        throw error;
      }

      return nwExternalPaymentsServiceInstance
        .createUserOrderExternalManagedPaymentsDetails(requestObject)
        .then((response) => {
          try {
            const payload =
              response != null && typeof response === 'object' ? response : {};
            CreateUserOrderExternalManagedPaymentsDetailsResponseSchema.parse(
              payload
            );
          } catch (error) {
            console.error('Invalid response object:', error);
            throw error;
          }
          return response;
        });
    };

    const { mutateAsync, isLoading, isError, error, status, reset } = useMutation(
      createUserOrderExternalManagedPaymentsDetails,
      {
        mutationKey: ['createUserOrderExternalManagedPaymentsDetailsApi']
      }
    );

    return {
      createUserOrderExternalManagedPaymentsDetailsApi: mutateAsync,
      isLoading,
      isError,
      error: error ? getAPIErrorMessage(error) : null,
      status,
      reset
    };
  };

export { useCreateUserOrderExternalManagedPaymentsDetailsApi };
